<div aria-labelledby="loggoff page">
    <header class="b-top border-xl core-water-leaf-border" >
        <a href="/"><img width="200px" src="./assets/alight_worklife_logo_black.svg" /></a>
        <div class="profile">
            <i class="fa-light fa-circle-user fa-xl"></i>
          <span style="color: rgb(20, 134, 249);">
            <i class="fa-light fa-globe fa-xl"></i>
            EN
          </span>
        </div>
    </header>
    <f-divider color="neutral-mountain-mist"/>
    <div class="main">
        <h4>You've Logged Off</h4>
        <p class = "logged-out-font">
            <br>By logging off, you prevent others from accessing your personal information. 
            <br>
            <br>Be sure to close any windows that might contain sensitive details.
        </p>
    </div>
</div>


            